import usePreferredUnits from '@components/UnitCalendarPage/utilities/usePreferredUnits';
import { useAsyncCollection } from '../useAsyncCollection/useAsyncCollection';
import { ENDPOINT_USER_UNITS } from '@utilities/apiConstants';
import { Unit } from '@data/unit/Unit';
import React from 'react';

export const usePreferredUnitsWithFaxNumber = () => {
	const [preferredUnitsWithFaxNumber, setPreferredUnitsWithFaxNumber] = React.useState<Unit[]>([]);
	const { indexedById: preferredUnitsById } = usePreferredUnits();
	const unitsPromise = useAsyncCollection<Unit>(ENDPOINT_USER_UNITS);
	React.useEffect(() => {
		void unitsPromise
			.then(allUnits => {
				setPreferredUnitsWithFaxNumber(
					Object.values(allUnits.reduce((acc: Record<string, Unit>, unit) => {
						const isPreferred = !!preferredUnitsById[unit.id];
						const hasFaxNumber = !!unit.faxNumber;
						const faxNumberAlreadyAdded = !!acc[unit.id];
						if (isPreferred && hasFaxNumber && !faxNumberAlreadyAdded) {
							acc[unit.id] = unit;
						}
						return acc;
					}, {}))
				);
			});
	}, [preferredUnitsById, unitsPromise]);
	return preferredUnitsWithFaxNumber;
};
